import { Props } from '../types';
import { NarrativeFeedback } from '../../NarrativeFeedback';
import { NarrativeHeader } from '../../PublicNarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';

import { useCallback } from 'react';

export const DesktopLayout = ({
  errors,
  values,
  onChange,
  isLoading,
  onSubmit,
  submitLabel,
  author,
  initialContentHtml,
  company,
  onReset,
  pastAnnualRevenueEarnings,
  narrativeId,
}: Props) => {
  const onContentChange = useCallback(
    (content: { text: string; html: string }) => onChange({ content }),
    [onChange]
  );
  return (
    <>
      <div className="grid grid-rows-[min-content_min-content_auto] content-start gap-x2">
        <NarrativeHeader
          errors={errors}
          values={values}
          onChange={onChange}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={submitLabel}
          author={author}
        />
        <NarrativeFeedback />
        <PublicNarrativeRichTextEditor
          onUpdate={onContentChange}
          defaultContent={initialContentHtml}
        />
      </div>

      <NarrativeSidebar
        company={company}
        onChange={onChange}
        values={values}
        onReset={onReset}
        readOnly={false}
        authorDisplayName={author.displayName || author.name}
        pastAnnualRevenueEarnings={pastAnnualRevenueEarnings}
        narrativeId={narrativeId}
      />
    </>
  );
};
